// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reactgrid input {
  border: none 
}

.reactgrid-content .rg-pane .rg-cell {
  color: black
}`, "",{"version":3,"sources":["webpack://./src/lib/styles.css"],"names":[],"mappings":"AAAA;EACE;AACF;;AAEA;EACE;AACF","sourcesContent":[".reactgrid input {\r\n  border: none \r\n}\r\n\r\n.reactgrid-content .rg-pane .rg-cell {\r\n  color: black\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
